import ClusterShare from "./ClusterShare";
import ClusterPost from "./ClusterPost";
import IndivisualClusterHeading from "./IndivisualClusterHeading";
import ToggleCluster from "./ToggleCluster";
const ClusterHome = () => {
  return (
    <div className="mt-24">
      <IndivisualClusterHeading />
      <ClusterShare />
      <ToggleCluster />
    </div>
  );
};
export default ClusterHome;
///api/cluster/getclusterbyid
